import {
  WebDashboard,
  ForgotPassword,
  Login,
  VerifyOtp,
  ResetPassword,
  GrowerManagement,
  GrowerDetail,
  FieldManagement,
  SplashScreen,
  ChangePassword,
  ProfileScreen,
  ScoutingManagement,
  CropPlanManagement,
  FieldManagementDetail,
  ScoutingDetail,
  AddCropPlan,
  CropPlanDetail,
  PrivacyPolicy,
  AboutUs,
  TermConditions,
  CropPlaneEdit,
} from "#pages";

const WebBaseURL = "/web";

const WebRoutePath = {
  SPLASH: {
    accessible: true,
    component: <SplashScreen />,
    exact: true,
    path: `${WebBaseURL}/splash`,
    title: "Login Page",
    type: "non-private",
  },
  LOGIN: {
    accessible: true,
    component: <Login />,
    exact: true,
    path: `${WebBaseURL}/login`,
    title: "Login Page",
    type: "non-private",
  },
  FORGOT_PASSWORD: {
    accessible: true,
    component: <ForgotPassword />,
    exact: true,
    path: `${WebBaseURL}/forgot-password`,
    title: "Forgot Password Page",
    type: "non-private",
  },
  VERIFY_OTP: {
    accessible: true,
    component: <VerifyOtp />,
    exact: true,
    path: `${WebBaseURL}/verify-otp`,
    title: "Verify Otp Page",
    type: "non-private",
  },
  RESET_PASSWORD: {
    accessible: true,
    component: <ResetPassword />,
    exact: true,
    path: `${WebBaseURL}/reset-password`,
    title: "Reset Password Page",
    type: "non-private",
  },
  CHANGE_PASSWORD: {
    accessible: true,
    component: <ChangePassword />,
    exact: true,
    path: `${WebBaseURL}/profile/change-password`,
    title: "Reset Password Page",
    type: "non-private",
  },
  PROFILE: {
    accessible: true,
    component: <ProfileScreen />,
    exact: true,
    path: `${WebBaseURL}/profile`,
    title: "Reset Password Page",
    type: "non-private",
  },

  DASHBOARD: {
    accessible: true,
    component: <WebDashboard />,
    exact: true,
    path: `${WebBaseURL}/dashboard`,
    title: "Dashboard",
    type: "private",
  },

  GROWER_MANAGEMENT: {
    accessible: true,
    component: <GrowerManagement />,
    exact: true,
    path: `${WebBaseURL}/grower-management`,
    title: "Grower Management",
    type: "private",
  },
  GROWER_DETAIL: {
    accessible: true,
    component: <GrowerDetail />,
    exact: true,
    path: `${WebBaseURL}/grower-management/grower-detail`,
    title: "Grower Detail",
    type: "private",
  },
  SCOUTING_MANAGEMENT: {
    accessible: true,
    component: <ScoutingManagement />,
    exact: true,
    path: `${WebBaseURL}/scouting-management`,
    title: "Scouting Management",
    type: "private",
  },
  SCOUTING_DETAIL: {
    accessible: true,
    component: <ScoutingDetail />,
    exact: true,
    path: `${WebBaseURL}/grower-management/grower-detail/scouting-detail`,
    title: "Scouting Detail",
    type: "private",
  },
  CROP_PLAN_MANAGEMENT: {
    accessible: true,
    component: <CropPlanManagement />,
    exact: true,
    path: `${WebBaseURL}/crop-plan-management`,
    title: "Crop Plan Management",
    type: "private",
  },
  ADD_CROP_PLAN_MANAGEMENT: {
    accessible: true,
    component: <AddCropPlan />,
    exact: true,
    path: `${WebBaseURL}/grower-management/grower-detail/add-crop-plan`,
    title: " Add Crop Plan Management",
    type: "private",
  },
  EDIT_CROP_PLAN_MANAGEMENT: {
    accessible: true,
    component: <CropPlaneEdit />,
    exact: true,
    path: `${WebBaseURL}/grower-management/grower-detail/crop-plan-detail/edit-crop-plan`,
    title: " Edit Crop Plan Management",
    type: "private",
  },
  CROP_PLAN_DETAIL: {
    accessible: true,
    component: <CropPlanDetail />,
    exact: true,
    path: `${WebBaseURL}/grower-management/grower-detail/crop-plan-detail`,
    title: "Crop Plan Detail",
    type: "private",
  },
  FIELD_MANAGEMENT: {
    accessible: true,
    component: <FieldManagement />,
    exact: true,
    path: `${WebBaseURL}/field-management`,
    title: "Field Management",
    type: "private",
  },
  FIELD_MANAGEMENT_DETAIL: {
    accessible: true,
    component: <FieldManagementDetail />,
    exact: true,
    path: `${WebBaseURL}/field-management/field-detail`,
    title: "Field Management",
    type: "private",
  },
  PRIVACY_POLICY: {
    accessible: true,
    component: <PrivacyPolicy />,
    exact: true,
    path: `${WebBaseURL}/privacy-policy`,
    title: "Privacy Policy",
    type: "private",
  },
  ABOUT_US: {
    accessible: true,
    component: <AboutUs />,
    exact: true,
    path: `${WebBaseURL}/about-us`,
    title: "About Us",
    type: "private",
  },
  TERMS_CONDITIONS: {
    accessible: true,
    component: <TermConditions />,
    exact: true,
    path: `${WebBaseURL}/terms-conditions`,
    title: "Terms & Conditions",
    type: "private",
  },
};

export { WebRoutePath };
